"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePlaylist = _interopRequireDefault(require("./base-playlist"));

var _playlistParser = require("../parsers/playlist/playlist-parser");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * A Master Playlist provides a set of Variant Streams, each of which
   describes a different version of the same content.

   A Variant Stream includes a Media Playlist that specifies media
   encoded at a particular bit rate, in a particular format, and at a
   particular resolution for media containing video.

   A Variant Stream can also specify a set of Renditions.  Renditions
   are alternate versions of the content, such as audio produced in
   different languages or video recorded from different camera angles.

   Clients should switch between different Variant Streams to adapt to
   network conditions.  Clients should choose Renditions based on user
   preferences.

 */
var MasterPlaylist =
/*#__PURE__*/
function (_Playlist) {
  _inherits(MasterPlaylist, _Playlist);

  function MasterPlaylist(playlistStruct, body) {
    var _this;

    _classCallCheck(this, MasterPlaylist);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MasterPlaylist).call(this, playlistStruct, body));
    _this.variants = [];
    _this.objType = 'MasterPlaylist';
    (0, _playlistParser.configureMasterPlaylist)(_assertThisInitialized(_assertThisInitialized(_this)), playlistStruct);
    return _this;
  }

  _createClass(MasterPlaylist, [{
    key: "basePath",
    set: function set(val) {
      this._basePath = val;

      if (this.variants) {
        this.variants.forEach(function (v) {
          return v.basePath = val;
        });
      }

      if (this.renditions) {
        this.renditions.forEach(function (v) {
          return v.basePath = val;
        });
      }
    },
    get: function get() {
      return this._basePath;
    }
    /**
     * get regularVariants - Get variant streams that are regular
     *
     * @return {Array<VariantStream>}  An array of variant streams that are 'regular' non-iFrame
     */

  }, {
    key: "regularVariants",
    get: function get() {
      return this.variants.filter(function (vs) {
        return vs.isIFrame == false;
      });
    }
    /**
     * get iFrameVaraints - Get variant streams that are iFrame only
     *
     * @return {Array<VariantStream>} An array of variant streams that are iFrame only
     */

  }, {
    key: "iFrameVaraints",
    get: function get() {
      return this.variants.filter(function (vs) {
        return vs.isIFrame == true;
      });
    }
    /**
     * get variantsAllHaveCodecsInfo - Master playlists contain a list of variants that sometimes have codec information and sometimes does not.
     * This is used to determine if they all have codecs or not
     *
     * @return {type}  description
     */

  }, {
    key: "variantsAllHaveCodecsInfo",
    get: function get() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.regularVariants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var variant = _step.value;

          if (variant.codecs === undefined || variant.codecs === null) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }
    /**
     * get lowestBandwidthVariant - Returns variants with the lowest bandwidth rate
     *
     * @return {Variant} Variant with the lowest bandwidth
     */

  }, {
    key: "lowestBandwidthVariant",
    get: function get() {
      return lowestBandWidthVariant(this.regularVariants);
    }
    /**
     * get audioOnlyVariants - Return variants that are labeled as audio only
     *
     * @return {Array<Variant>} An array of variants
     */

  }, {
    key: "audioOnlyVariants",
    get: function get() {
      return this.regularVariants.filter(function (v) {
        return v.codecs !== undefined;
      }).filter(function (v) {
        return v.codecs.split(',').length === 1;
      });
    }
    /**
     * get completeVariants - Return variants that might have both audio & video.
     * Variants that aren't labeled
     *
     * @return {Array<Variant>}
     */

  }, {
    key: "completeVariants",
    get: function get() {
      if (this.variantsAllHaveCodecsInfo) {
        /// Kind of dumb, but maybe kind of not?
        /// Filter most tracks based on the highest amount of codecs listed
        var codecsCnt = unique(this.regularVariants.map(function (v) {
          return v.codecs.split(',').length;
        }));
        var trackMax = codecsCnt.reduce(function (a, b) {
          return Math.max(a, b);
        });
        return this.regularVariants.filter(function (v) {
          return v.codecs.split(',').length === trackMax;
        });
      } else {
        var results = this.regularVariants.filter(function (v) {
          return v.codecs === undefined;
        });
        return results;
      }
    }
  }]);

  return MasterPlaylist;
}(_basePlaylist.default);

var lowestBandWidthVariant = function lowestBandWidthVariant(variants) {
  return variants.sort(function (a, b) {
    return a.bandwidth - b.bandwidth;
  })[0];
};

var unique = function unique(arr) {
  return arr.filter(function (val, idx, self) {
    return self.indexOf(val) === idx;
  });
};

var _default = MasterPlaylist;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/playlists/master-playlist.js
// module id = 479
// module chunks = 0